import type { Chart, IAxisLabelRenderEventArgs, IPointRenderEventArgs, SeriesModel } from '@syncfusion/ej2-charts';

interface WeightDataItem {
    Date: string;
    Weight: number;
    HidePoint: boolean;
    Colour: string;
}

export async function weightchart(appendTo: string, measuredData: WeightDataItem[], estimatedData: WeightDataItem[], targetData: WeightDataItem[]) {

    await import('./loadSyncfusion');

    const { Chart, LineSeries, Category, Tooltip, Legend, MultiColoredLineSeries } = await import('@syncfusion/ej2-charts');

    Chart.Inject(LineSeries, Category, Tooltip, Legend, MultiColoredLineSeries);

    const commonFont = { color: '#fff', fontFamily: 'Helvetica' };

    const series: SeriesModel[] = [
        {
            type: 'Line',
            dataSource: measuredData,
            xName: 'Date',
            yName: 'Weight',
            name: 'Measured Weight',
            marker: { visible: true, width: 5, height: 5 },
            width: 2,
            fill: '#00FF00',
            emptyPointSettings: {
                mode: 'Drop'
            }
        },
        //{
        //    type: 'Line',
        //    dataSource: estimatedData,
        //    xName: 'Date',
        //    yName: 'Weight',
        //    name: 'Estimated Weight',
        //    dashArray: '5,5',
        //    marker: { visible: true, width: 5, height: 5 },
        //    width: 2,
        //    fill: '#FFA500'
        //}
    ];

    if (targetData.length > 0) {
        series.push({
            type: 'Line',
            dataSource: targetData,
            xName: 'Date',
            yName: 'Weight',
            name: 'Target Weight',
            marker: { visible: false },
            width: 2,
            fill: '#FF0000',
            emptyPointSettings: {
                mode: 'Drop'
            }
        });
    }

    const chart: Chart = new Chart({
        primaryXAxis: {
            valueType: 'Category',
            majorGridLines: { width: 0 },
            labelStyle: commonFont,
            labelIntersectAction: 'Hide'
        },
        primaryYAxis: {
            majorGridLines: { width: 1, color: '#777' },
            lineStyle: { width: 0 },
            labelStyle: commonFont,
            titleStyle: commonFont,
            title: 'Weight (kg)'
        },
        series: series,
        tooltip: {
            enable: true,
            format: '${point.x} <br> ${series.name}: ${point.y} kg',
        },
        legendSettings: { visible: true, textStyle: commonFont },
        background: 'transparent',
        width: '100%',
        height: '100%',
        
        axisLabelRender: (args: IAxisLabelRenderEventArgs) => {
            if (args.axis.name === 'primaryXAxis') {
                const date = new Date(args.text);
                const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
                args.text = date.toLocaleDateString('en-NZ', options);
            }
        },        
        pointRender: (args: IPointRenderEventArgs) => {
            if (args.series.name === 'Measured Weight') {
                const point = measuredData[args.point.index];
                if (point.HidePoint) {
                    args.point.visible = false;
                    args.shape = 'None';
                    args.series.fill = "#FFFFFF";
                } else {
                    //args.fill = '#00FF00';
                    //args.width = 5;
                    //args.height = 5;
                    args.series.fill = '#00FF00';
                }
            } else if (args.series.name === 'Estimated Weight') {
                const point = estimatedData[args.point.index];
                if (point.HidePoint) {
                    args.point.visible = false;
                    args.shape = 'None';
                    args.series.fill = "#FFFFFF";
                } else {
                    //args.fill = '#FFA500';
                    //args.width = 5;
                    //args.height = 5;
                    args.series.fill = '#FFA500';
                }
            }
        }
    });

    chart.appendTo(appendTo);
}
